import { render, staticRenderFns } from "./SaldoInvestimento.vue?vue&type=template&id=72483a38"
import script from "./SaldoInvestimento.vue?vue&type=script&lang=js"
export * from "./SaldoInvestimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports